import React from "react";
import styles from "./index.module.css";
import Select from 'react-select'

const Select_ = ({ id, label, subLabel = null, key, required=false, ...selectProps }) => {

    const customStyles = {
        control: (provided,state) => ({
          ...provided,
          minHeight: '3.6rem', 
          height: "3.6rem",     
          padding: "0",         
          fontSize: "1.6rem", 
          fontFamily:"Arial",
          outine:"none",
          
          boxShadow: state.isFocused ? 'none' : provided.boxShadow, 
          borderColor: state.isFocused ? 'none' : provided.borderColor, 
          border:"1px solid var(--border-color)",
          "&:hover": {
            borderColor: '#ccc', 
            backgroundColor: 'transparent', 
          },        
          
        }),
        input: (provided) => ({
          ...provided,
          margin: '0',          
          padding: '0',         
          fontSize: "1.6rem", 
          fontFamily:"Arial"


        }),
        valueContainer: (provided,state) => ({
          ...provided,
          height: '3.6rem',     
          padding: '0 8px',     
          fontSize: "1.2rem", 
          fontFamily:"Arial",
          borderColor: state.isFocused ? 'none' : provided.borderColor, 

   

        }),
        menu: (provided) => ({
          ...provided,
          // maxHeight: '10rem',   
          fontSize: "1.6rem", 
          fontFamily:"Arial"


        }),
        option: (provided) => ({
          ...provided,
          padding: '10px',      
          fontSize: "1.6rem", 
          // fontFamily:"Arial",
          color:"black"


        }),
        indicatorSeparator: () => ({
          display: 'none',
        }),
    };

    return (
        <div className={styles.formGroup} style={selectProps.formGroupStyleOverride} key={key}>
            {label && <label htmlFor={id}>{label} {required&&<span className="required">*</span>}</label>}
            {subLabel && <label className={styles.subLabel}>{subLabel}</label>}
            <Select 
                required 
                {...selectProps} 
                styles={customStyles} 
                menuPortalTarget={document.body}
                menuPosition="fixed"
            />
        </div>
    );
};

export default Select_;
